import Modal from './Components/Modal';
import GalleryImageCell from './Components/GalleryImageCell';
const images = require.context('./images/projects', false);
const imageList = images.keys().map(image => images(image));

function Gallery() {

  return (
    <section id='GallerySection' className='container'>
      <div className="gallery-section-wrapper">
        <h2 className="section-header asset-underline">our gallery of work</h2>
        <div className="gallery-wrapper">
          <div className="gallery-item">
            <p className="paragraph">Are you looking to freshen up and modernize your home? Look no further! Centerline Cabinets has all of your cabinets, shelving, and storage needs covered. No job is to large or small for us. Providing highest quality products built to exacting tolerances is our priority.</p>
          </div>
          {imageList.map((image, index) => (
            <GalleryImageCell key={index} index={index} image={image}/>
          ))}
        
        </div>
      </div>
      <Modal/>
    </section>
  )
}

export default Gallery